<template>
    <Hamburger :navigation="navigation" @navigate="navigate( $event.event, $event.index )" />
    <div class="navigation large">
        <template v-for="( nav, index ) in navigation[ $core.getConfig().showMaintenance() ][$store.getters.authorized]" :key="'nav-'+index">
            <a v-if="!nav.level || nav.level <= $store.getters.level"
               :class="'item'+( nav.name === $route.name ? ' active' : '' )" @click="navigate( $event, index )">
                {{ nav.label }}
            </a>
        </template>
    </div>
</template>

<script>
import Hamburger from '@/components/layout/parts/navigation/Hamburger'

export default {
    
    name:       'Navigation',
    components: { Hamburger },
    data()
    {
        return {
            
            navigation: {
                true: {
                    true:  [
                        {
                            label: 'Dashboard',
                            name:  'default'
                        },
                        {
                            label: 'Admin',
                            name:  'admin',
                            level: 5
                        },
                        {
                            label: 'Abmelden',
                            name:  'logout'
                        }
                    ],
                    false: [
                        {
                            label: 'Startseite',
                            name:  'default'
                        },
                        {
                            label: 'Kontakt',
                            name:  'contact'
                        },
                        {
                            label: 'Impressum',
                            name:  'imprint'
                        }
                    ],
                },
                false: {
                    true:  [
                        {
                            label: 'Dashboard',
                            name:  'default'
                        },
                        {
                            label: 'Profil',
                            name:  'profile'
                        },
                        {
                            label: 'Postfach',
                            name:  'mailbox'
                        },
                        {
                            label: 'Match-Maker',
                            name:  'matchmaker'
                        },
                        {
                            label: 'Chat',
                            name:  'chat'
                        },
                        {
                            label: 'Shoutboard',
                            name:  'shoutboard'
                        },
                        {
                            label: 'Einstellungen',
                            name:  'settings'
                        },
                        {
                            label: 'Hilfe',
                            name:  'help'
                        },
                        {
                            label: 'Admin',
                            name:  'admin',
                            level: 5
                        },
                        {
                            label: 'Abmelden',
                            name:  'logout'
                        }
                    ],
                    false: [
                        {
                            label: 'Startseite',
                            name:  'default'
                        },
                        {
                            label: 'Preise',
                            name:  'pricing'
                        },
                        {
                            label: 'Kontakt',
                            name:  'contact'
                        },
                        {
                            label: 'Impressum',
                            name:  'imprint'
                        }
                    ],
                }
            }
            
        }
    },
    methods: {
        navigate( event, index )
        {
            this.$core.f().skip( event )
            if( this.$store.getters.authorized )
            {
                this.$core.getClient()
                    .request({
                        method: 'basic.updateLocation',
                        location: this.navigation[ this.$core.getConfig().showMaintenance() ][ this.$store.getters.authorized ][ index ].name
                    })
            }

            if ( 'logout' === this.navigation[ this.$core.getConfig().showMaintenance() ][ this.$store.getters.authorized ][ index ].name ) {
                this.$core
                    .ui()
                    .simpleModalDialog( 'Abmelden', 'Bist du dir sicher, dass du deine aktive Sitzung beenden möchtest?' )
                    .then( () =>
                    {
                        this.$core.getAuthenticator()
                            .tryLogout()
                    } )
                    .catch( () =>
                    {
                    } )
                return
            }
            this.$router.push( { name: this.navigation[ this.$core.getConfig().showMaintenance() ][ this.$store.getters.authorized ][ index ].name } );
        }
    }
}
</script>